'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _OMTitle = require('./OMTitle.scss');var _OMTitle2 = _interopRequireDefault(_OMTitle);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var OMTitle = function OMTitle(properties) {return (
    _react2.default.createElement('h1', { className: _OMTitle2.default[properties.className] },
      properties.title));};exports.default =



OMTitle;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMTitle/OMTitle.js
// module id = 279
// module chunks = 0